import React, { useEffect, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { FormControl, FormLabel, Input, FormHelperText } from "@mui/joy";
import ReactQuill from "react-quill";
import { connect, useDispatch } from "react-redux";
import {
  get_sell_item_content,
  create_faq_question, 
} from "../../reduxData/cms/cmsAction";
import { useSelector } from "react-redux";

const modules = {
  toolbar: [
    [{ font: [] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ color: [] }, { background: [] }],
    ["link"],
  ],
};

const ReputationContent = ({ sellItemCont }) => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const [fullContent, setFullContent] = useState(null);
  
  const [reputationSections, setReputationSections] = useState([]);
  const [errors, setErrors] = useState([]);

  const [isPermission, setIsPermission] = useState(false);
  useEffect(() => {
    setIsPermission(
      (user?.role === "staff" && user?.permission?.p_staff > 1) ||
        user?.role !== "staff"
        ? true
        : false
    );
  }, [user]);

  useEffect(() => {
    get_sell_item_content(
      localStorage.getItem("token"),
      "aboutus_content",
      dispatch
    );
  }, [dispatch]);

  useEffect(() => {
    if (sellItemCont?.length > 0) {
      const content = sellItemCont[0]?.content || {};
      setFullContent(content); 
      setReputationSections(content.reputationSections || []); 
      setErrors(
        (content.reputationSections || []).map(() => ({ title: null, details: null }))
      );
    }
  }, [sellItemCont]);


  const handleAddSection = () => {
    setReputationSections([
      ...reputationSections,
      { title: "", details: "" },
    ]);
    setErrors([...errors, { title: null, details: null }]);
  };

  const handleRemoveSection = (index) => {
    setReputationSections(reputationSections.filter((_, i) => i !== index));
    setErrors(errors.filter((_, i) => i !== index));
  };

  const handleSectionChange = (value, index, field) => {
    const newSections = [...reputationSections];
    newSections[index][field] = value;
    setReputationSections(newSections);

    if (value && (field === "title" || value !== "<p><br></p>")) {
      const newErrors = [...errors];
      newErrors[index][field] = null;
      setErrors(newErrors);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    let formIsValid = true;
    const newErrors = reputationSections.map((section) => {
      const sectionErrors = {};
      if (!section.title) {
        sectionErrors.title = "Title is required";
        formIsValid = false;
      }
      if (!section.details || section.details === "<p><br></p>") {
        sectionErrors.details = "Details are required";
        formIsValid = false;
      }
      return sectionErrors;
    });

    setErrors(newErrors);

    if (!formIsValid) {
      return;
    }

    const updatedContent = {
      ...fullContent, 
      reputationSections: reputationSections, 
    };

    const quest_data = {
      name: "aboutus_content",
      type: "aboutus_content",
      status: sellItemCont[0]?.status || false,
      content: updatedContent,
      removeVideos: [], 
      removePhotos: [],
    };

    await create_faq_question(
      localStorage.getItem("token"),
      quest_data,
      sellItemCont[0]?._id, 
      dispatch
    );
    
    get_sell_item_content(
      localStorage.getItem("token"),
      "aboutus_content",
      dispatch
    );
  };

  return (
    <div>
      <div className="container">
        <h3 className="mb-2 fw-600">Reputation System Content</h3>
       
      </div>
      <Form onSubmit={handleSubmit}>
        <Accordion defaultActiveKey="0" alwaysOpen>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <h4 className="fw-600 ms-2">Reputation Sections</h4>
            </Accordion.Header>
            <Accordion.Body>
              {reputationSections.map((section, index) => (
                <div key={index} className="border p-3 mb-3 rounded">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">Section {index + 1}</h5>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleRemoveSection(index)}
                      disabled={!isPermission}
                    >
                      Remove Section
                    </Button>
                  </div>

                  <FormControl className="mt-2 mb-2">
                    <FormLabel className="fw-600 text-dark">Title</FormLabel>
                    <Input
                      type="text"
                      name="title"
                      placeholder="e.g., Buyer, Seller, Important"
                      value={section.title}
                      disabled={!isPermission}
                      onChange={(e) =>
                        handleSectionChange(e.target.value, index, "title")
                      }
                    />
                    {errors[index]?.title && (
                      <FormHelperText style={{ color: "red" }}>
                        {errors[index].title}
                      </FormHelperText>
                    )}
                  </FormControl>

                  <FormControl className="mt-2 mb-2">
                    <FormLabel className="fw-600 text-dark">
                      Details (Bullet Points)
                    </FormLabel>
                    <ReactQuill
                      name="details"
                      value={section.details}
                      placeholder="Enter bullet points..."
                      modules={modules}
                      disabled={!isPermission}
                      onChange={(value) =>
                        handleSectionChange(value, index, "details")
                      }
                    />
                    {errors[index]?.details && (
                       <FormHelperText style={{ color: "red" }}>
                        {errors[index].details}
                      </FormHelperText>
                    )}
                  </FormControl>
                </div>
              ))}
              <Button
                type="button"
                className="btn content-button mt-2"
                onClick={handleAddSection}
                disabled={!isPermission}
              >
                Add New Section
              </Button>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        <Button
          type="submit"
          className="btn common-button mt-3"
          disabled={!isPermission}
        >
          Save Reputation Content
        </Button>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    sellItemCont: state.cms.sellItemCont, 
  };
};

export default connect(mapStateToProps)(ReputationContent);